import React, { FunctionComponent } from 'react';

import Flex from '@gojob/ui-bits/Flex';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Dot from './Dot';

export type DotsProps = {
  renderAriaLabel?: (index: number) => string;
  onClick?: (index: number) => void;
  visibilities?: number[];
};

const Dots: FunctionComponent<DotsProps> = (props) => {
  const { onClick, renderAriaLabel, visibilities = [] } = props;
  const { spacing } = useTheme();

  const handleOnClick = (index: number) => () => onClick?.(index);
  const show = visibilities.filter((visibility) => visibility < 0.99).length;

  if (!show) {
    return null;
  }
  return (
    <Flex flexDirection="row" justifyContent="center">
      {visibilities.map((visibility, index) => {
        const opacity = Math.max(visibility, 0.3);
        const size = spacing(3 * visibility + 3);
        const ariaLabel = renderAriaLabel?.(index);

        return (
          <Dot
            data-testid={`Dot ${index}`}
            key={index}
            opacity={opacity}
            height={size}
            width={size}
            onClick={handleOnClick(index)}
            aria-label={ariaLabel}
          />
        );
      })}
    </Flex>
  );
};

export default Dots;
